// src/components/UpdateModal.js
import React from 'react';
import Modal from "react-bootstrap/Modal";
import Icons from "./Components/Icons/Icons";

// import Modal from 'react-modal';

// Modal.setAppElement('#root'); // Required for accessibility

const UpdateModal = ({ isOpen, onConfirm, onCancel }) => (
  <Modal
    size="lg" show={isOpen} onHide={onCancel}   
    backdrop="static"
    centered >
    <Modal.Header className='bg-warning text-white justify-content-center'> <h3 className='mb-0'> 
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16" id="exclamation-mark">
                  <path fill="#fdfdfdff" d="M8,2 C6.70088,2 5.72131,3.18031 5.96072,4.45718 L6.81571,9.01713 C6.92257,9.58703 7.42017,10 8,10 C8.57983,10 9.07743,9.58703 9.18429,9.01713 L10.0393,4.45718 C10.2787,3.18031 9.29912,2 8,2 Z M8,11 C8.82843,11 9.5,11.6716 9.5,12.5 C9.5,13.3284 8.82843,14 8,14 C7.17157,14 6.5,13.3284 6.5,12.5 C6.5,11.6716 7.17157,11 8,11 Z M8,12 C7.72386,12 7.5,12.2239 7.5,12.5 C7.5,12.7761 7.72386,13 8,13 C8.27614,13 8.5,12.7761 8.5,12.5 C8.5,12.2239 8.27614,12 8,12 Z M8,3 C8.67298,3 9.18043,3.61144 9.05641,4.27289 L9.05641,4.27289 L8.20142,8.83284 C8.18324,8.92976 8.09861,9 8,9 C7.90139,9 7.81676,8.92976 7.79858,8.83284 L7.79858,8.83284 L6.94359,4.27289 C6.81957,3.61144 7.32702,3 8,3 Z"></path>
              </svg> Important Message  </h3> 
    </Modal.Header>

    <Modal.Body className=''>
      <div className=''> 

          <div className='card'> 
             <div className='card-header text-center'> <h2 className='mb-0 text-danger'>A new update is available. Reload now</h2></div>
             <div className='card-body'> 
                <div style={{position: 'relative',top:'-60px', textAlign:'center'}} className='animated slideInUp'>  <Icons iconType={'UpdateIllustration'} /> </div>
                <div className='textCard animated slideInDown'>
                  <h3> This update will apply improvements or fixes to the current application.</h3> 
                  <h3> It may refresh the interface or underlying functionality but is designed not to alter your existing settings, preferences, or stored data. </h3>
                  <h3>Reloading ensures you're using the most secure and optimized version of the app.</h3>
                </div>
              </div>
              
          </div>
          
      </div>
       


         

      
    
    </Modal.Body>
    <Modal.Footer>
        {/* <button className="btn secondary_bg" onClick={onCancel}>Later</button> */}
        {/* <button className="btn primary_bg" onClick={onConfirm}>Reload</button> */}
        <button className="btn btn-primary px-5" onClick={onConfirm}>Reload</button>
    </Modal.Footer>
  </Modal>
);

export default UpdateModal;
